import React from 'react';
import { withRouter } from 'react-router-dom';
import { I18n } from '../../../helpers/i18n';
import './SessionRatingModal.css';

import logoRating from '../../../static/images/mvp/logo_rating.png';

function RatingFloatNotification({ session, onDismiss, history }) {
  if (!session) return null;

  const sessionName = session.title || '';
  const buddyName = session.buddy?.name || session.senior?.name || '';
  const sessionDetailId = session.sessionUserId || session._id;

  const navigateToDetail = () => {
    history.push(`/session-detail/${sessionDetailId}`);
  };

  return (
    <div className="rating-float-notification">
      <div className="rating-float-notification-body" onClick={navigateToDetail}>
        <img
          className="rating-float-notification-avatar"
          src={logoRating}
          alt="CED"
        />
        <div className="rating-float-notification-info">
          <p className="rating-float-notification-title">
            {I18n.t('rate_recent_session')}
          </p>
          <p className="rating-float-notification-subtitle">
            {buddyName || sessionName}
          </p>
          <div className="rating-float-notification-stars">
            {[1, 2, 3, 4, 5].map((star) => (
              <span key={star} className="rating-float-star">☆</span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(RatingFloatNotification);
